import "./App.css";
import { Fragment, useEffect, useState } from "react";
import {
  Route,
  BrowserRouter as Router,
  Routes,
  useNavigate,
} from "react-router-dom";

import { Provider } from "react-redux";

// pages
import Register from "./pages/register/register";
import Login from "./pages/login/login";
import User from "./layout/User/User";

import { UserRoutes } from "./Routing/UserRoutes";
import { app, onMessageListener } from "./firebase";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useDispatch, useSelector } from "react-redux";
import store from "./store";
// controllers
import Redirect from "./controllers/reactRouter/Redirect";

import Invite from "./pages/Invite/Invite";
import { AgentRoutes } from "./Routing/AgentRoutes";
import PageNotFound from "./pages/PageNotFound/PageNotFound";
import InternalServerError from "./pages/InternalServerError/InternalServerError";
import ConnectionTimeout from "./pages/ConnectionTimeout/ConnectionTimeout";
import UnAuthorizedPage from "./pages/UnAuthorizedPage/UnAuthorizedPage";
import EmailVerification from "./pages/EmailVerification/EmailVerification";
import SuccessVerification from "./pages/SuccessVerification/SuccessVerification";
import UpdateProfile from "./pages/UpdateProfile/UpdateProfile";
import { AdminRoutes } from "./Routing/AdminRoutes";
// import { httpsCallable } from "firebase/functions";
// import { functions } from "./firebase";

// import PhoneVerificationComponent from "./pages/PhoneVerificationComponent/PhoneVerificationComponent";

window.location.host === "landbook-app.web.app" &&
  window.location.replace("http://app.landbook.pk");

function App() {
  const dispatch = useDispatch();
  const [AuthPending, setAuthPending] = useState(false);
  const [isUserSuperAdmin, setIsUserSuperAdmin] = useState(false);

  const user = useSelector((state) => state);

  useEffect(() => {
    setAuthPending(true);
    getAuth().onAuthStateChanged(async (result) => {
      //checking if the user is super admin
      // const addAdminRole = httpsCallable(functions, "addAdminRole");
      // await addAdminRole({ email: "ahmersaud20@gmail.com" });
      if (result) {
        result.getIdTokenResult().then((idTokenResult) => {
          if (idTokenResult.claims.admin) {
            setIsUserSuperAdmin(true);
          }
        });
      }
      setAuthPending(false);
      dispatch({
        type: "ADD_NEW_USER",
        payload: result,
      });

      return false;
    });
  }, []);

  return (
    <Provider store={store}>
      <Fragment>
        {/* <div className="h-100"> */}
        <Router>
          <Routes>
            <Route path={"/user"} element={<User />}>
              {!isUserSuperAdmin
                ? UserRoutes &&
                  UserRoutes.filter((routes) => routes.layout === "user").map(
                    (UserRoutes) => {
                      return (
                        <Route
                          key="{user}"
                          path={UserRoutes.path.split("/user/").pop()}
                          element={UserRoutes.component}
                        />
                      );
                    }
                  )
                : AdminRoutes &&
                  AdminRoutes.filter((routes) => routes.layout === "user").map(
                    (AdminRoute) => {
                      return (
                        <Route
                          key="{user}"
                          path={AdminRoute.path.split("/user/").pop()}
                          element={AdminRoute.component}
                        />
                      );
                    }
                  )}
            </Route>
            <Route path={"/:linkId"} element={<Invite />} />
            <Route path={"/verify/email"} element={<EmailVerification />} />
            <Route
              path={"/verify/email/success"}
              element={<SuccessVerification />}
            />
            {/* <Route
              path={"/verify/phone"}
              element={<PhoneVerificationComponent />}
            /> */}
            <Route path={"/login"} element={<Login />} />
            <Route path={"/user/update/profile"} element={<UpdateProfile />} />
            <Route path={"/register"} element={<Register />} />
            <Route path={"/"} element={<Redirect />} />
            <Route path={"*"} exact element={<PageNotFound />} />
            <Route
              path={"/internal/server/error"}
              element={<InternalServerError />}
            />

            <Route
              path={"/connection/timeout"}
              element={<ConnectionTimeout />}
            />
          </Routes>
        </Router>
        {/* </div> */}

        <div id="reset-password-container"></div>
        <div id="recaptcha-container"></div>
      </Fragment>
    </Provider>
  );
}

export default App;
